import { FunctionComponent, h } from 'preact';
import { faMap } from '@fortawesome/pro-solid-svg-icons/faMap';
import { faSatellite } from '@fortawesome/pro-solid-svg-icons/faSatellite';
import { faMountains } from '@fortawesome/pro-solid-svg-icons/faMountains';
import MapSetting from './map-setting';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { useTranslation } from '../../../hooks/use-translation';

interface Props {
	onChange: (mapType: google.maps.MapTypeId) => void;
	onClose: () => void;
	currentMapType: google.maps.MapTypeId;
}

const MapSettingsMenu: FunctionComponent<Props> = ({ onClose, onChange, currentMapType }) => {
	const { t } = useTranslation();
	return (
		<card-component className="map-settings-menu" data-testid="map-settings-menu">
			<FontAwesomeIcon
				icon={faTimes}
				onClick={onClose}
				className="map-settings-close"
				aria-hidden="false"
				role="button"
				aria-label={t('CLOSE_MENU')}
			/>
			<MapSetting
				icon={faMap}
				text={t('TRACKING.MAP')}
				isActive={currentMapType === google.maps.MapTypeId.ROADMAP}
				mapType={google.maps.MapTypeId.ROADMAP}
				onClick={onChange}
			/>
			<MapSetting
				icon={faSatellite}
				text={t('TRACKING.SATELLITE')}
				isActive={currentMapType === google.maps.MapTypeId.SATELLITE}
				mapType={google.maps.MapTypeId.SATELLITE}
				onClick={onChange}
			/>
			<MapSetting
				icon={faMountains}
				text={t('TRACKING.TERRAIN')}
				isActive={currentMapType === google.maps.MapTypeId.TERRAIN}
				mapType={google.maps.MapTypeId.TERRAIN}
				onClick={onChange}
			/>
		</card-component>
	);
};

export default MapSettingsMenu;
